/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaGroupTeam = {
    properties: {
        fantaTeam: {
            type: 'FantaTeamSmall',
            isRequired: true,
        },
        state: {
            type: 'FantaGroupTeamState',
            isRequired: true,
        },
    },
} as const;
